<template>
  <div class="infoStatement">
       <!-- 余额表 -->
      <div class="list-head">
        <div class="fl mr50">
          <cc-datePicker
            pickerType="month"
            :clear="false"
            :specialPicker="dateLimit"
            :currentDate="currentDate"
            @changePicker="date => (currentDate = date)"
          ></cc-datePicker>
        </div>
        <div>
            <span class="mr50">科目：所有科目</span>
            <el-checkbox v-model="checked" @change="showChecked">仅显示有发生额的科目</el-checkbox>
        </div>
      </div>

      <cc-table
        :tableData="tableData"
        class="normal-table"
        :maxHeight ="pageHeight"
        stripe
        border
        show-summary
        v-loading="tableLoading"
        :pagination='false'
        tooltip-effect="dark" >
        <el-table-column prop="subjectCode" label="科目编号"> </el-table-column>
        <el-table-column prop="subjectName"  label="科目名称">
          <template slot-scope="scope">
            <el-link @click.stop="lookInfo(scope.row)">
              {{scope.row.subjectName}}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="debitMoney" label="借方发生额">
            <template slot-scope="scope">
                <span v-if="scope.row.debitMoney">{{ $formatNumber(scope.row.debitMoney)}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="lenderMoney" label="贷方发生额">
            <template slot-scope="scope">
                <span v-if="scope.row.lenderMoney">{{ $formatNumber(scope.row.lenderMoney) }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="balanceDir" label="余额方向"></el-table-column>
        <el-table-column prop="balance" key="balance" label="余额">
            <template slot-scope="scope">
                <span>{{ $formatNumber(scope.row.balance ) }}</span>
            </template>
        </el-table-column>
      </cc-table>

      <look-details v-if="isLook" :selectData="selectData" :currentDate="currentDate" @closeHandle="closeBounced"></look-details>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dateFormat, getHeight } from "_utils/utils";
import lookDetails from "./lookDetails"
export default {
  name: "toolCabinet",
  data() {
    return {
      currentDate: "",
      tableData:[],
      bouncedData:[],
      selectData:{},
      bookTimeInfo:{},
      subjectCode:'',
      showAmountIncurred:0,
      pageNum:0,
      pageSize:10,
      pageHeight: getHeight(300).toString(),
      tableLoading:false,
      isLook:false,
      checked:false,
    };
  },
  created() {
    this.requestCurrDate()
    // this.initData()
    this.scrollInit()
  },
  components: {
    lookDetails
  },
  methods: {
    scrollInit(){
       this.$nextTick(()=>{
        let element = document.querySelector('.is-scrolling-none')
        element.addEventListener('scroll',(evt)=>{
          let _this = evt.target;
          let sign = 10;
          const scrollDistance = _this.scrollHeight - _this.scrollTop - _this.clientHeight;//是否到底部
          let song = this.pageSize*this.pageNum >= this.bouncedData.length;
          if (scrollDistance <= sign && !song) {
            let start  = JSON.stringify(this.bouncedData)
            let end = JSON.parse(start)
            let slice = end.slice(this.pageSize,this.pageSize+10)
            this.tableData =this.tableData.concat(slice)
            this.pageSize += 10;
          }
        })
      })
    },
    initData(){//获取所有科目
        let {$axios} = this;
        this.tableLoading = true;
        $axios.https.post($axios.interfaceApi.detailList,{
          bookId:this.currAccount,
          date:this.currentDate,
          showAmountIncurred:this.showAmountIncurred,       //是否显示有发生额的科目(0表示不显示,1表示显示)
        })
        .then(res=>{
          this.tableLoading = false;
          this.bouncedData = res;
          let start  = JSON.stringify(this.bouncedData)
          let end = JSON.parse(start)
          this.tableData = end.slice(this.pageNum,this.pageSize)
          this.pageNum +=1;
        })
        .catch(req=>{
          this.tableLoading=false;
        })
    },
    requestCurrDate () {
      let { $axios, currAccount } = this;
      if(!currAccount){
        return
      }
      $axios.https
        .post(`${$axios.interfaceApi.GET_BOOKTIME}/${currAccount}`)
        .then(res => {
          let { commitTime, enableTime } = res;
          this.bookTimeInfo = res;
          //日期相同
          if (this.currentDate == commitTime) this.initData();
          else this.currentDate = commitTime;
        });
    },
    closeBounced(){
      this.isLook = false;
    },
    lookInfo(row){
      this.selectData = row;
      this.subjectCode = row.subjectCode;
      this.isLook = true;
    },
    showChecked(){      //仅显示有发生额的科目
        this.showAmountIncurred = this.checked?1:0;
        this.initData()
    }
  },
  watch: {
    currAccount (newVal) {
      this.requestCurrDate();
    },
    currentDate(newVal){
      this.initData()
    }
  },
  computed: {
    ...mapGetters("ModulesUser", {
      currAccount: "GET_BOOKID"
    }),
    dateLimit () {
      let { commitTime, enableTime } = this.bookTimeInfo;
      return {
        disabledDate (time) {
          if (commitTime && enableTime) {
            if (commitTime === enableTime)
              return (
                time.getFullYear() != new Date(commitTime).getFullYear() ||
                time.getMonth() != new Date(commitTime).getMonth()
              );
            return time > new Date(commitTime) || time < new Date(enableTime);
          }
          return true;
        }
      };
    }
  }
};
</script>

<style lang="scss" scope>
.infoStatement{
    height: 100%;
    width: 100%;
    background: #fff;
    .list-head {
        height: 60px;
        line-height: 60px;
        padding: 0px 30px;
    }
}


</style>
